import { CreateValues, EhrSystem, UpdateValues } from './models/ehrSystem';
import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(): Promise<EhrSystem[]> {
    const url = this.common.constructPath('/ehr-systems');
    const { ehrSystems } = await this.common.getJSON(url);
    return ehrSystems;
  }

  async findOneById(id: string): Promise<EhrSystem> {
    const url = this.common.constructPath(`/ehr-systems/${id}`);
    const { ehrSystem } = await this.common.getJSON(url);
    return ehrSystem;
  }

  async create(toAdd: CreateValues): Promise<EhrSystem> {
    const url = this.common.constructPath('/ehr-systems');
    const { ehrSystem } = await this.common.postJSON(url, toAdd);
    return ehrSystem;
  }

  async update(id: string, toUpdate: UpdateValues): Promise<EhrSystem> {
    const url = this.common.constructPath(`/ehr-systems/${id}`);
    const { ehrSystem } = await this.common.patchJSON(url, toUpdate);
    return ehrSystem;
  }

  async remove(id: string): Promise<boolean> {
    const url = this.common.constructPath(`/ehr-systems/${id}`);
    const { success } = await this.common.deleteJSON(url);
    return success;
  }
}
